import * as React from "react";

function SvgIcons8IphoneX(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#e38939"
        d="M36 8v32c0 2.2-1.8 4-4 4H16c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4z"
      />
      <path
        fill="#fff3e0"
        d="M16 42h16a2 2 0 002-2V8a2 2 0 00-2-2h-1a1 1 0 00-1 1 2 2 0 01-2 2h-8a2 2 0 01-2-2 1 1 0 00-1-1h-1a2 2 0 00-2 2v32a2 2 0 002 2z"
      />
      <path
        fill="#f9b27d"
        d="M30 27.539c-.328.676-.485.978-.907 1.578-.589.832-1.42 1.875-2.45 1.883-.913.006-1.147-.555-2.389-.547-1.24.003-1.501.555-2.415.547-1.029-.008-1.814-.945-2.405-1.781-1.646-2.337-1.82-5.078-.803-6.535.721-1.035 1.863-1.641 2.934-1.641 1.089 0 1.775.559 2.676.559.875 0 1.407-.559 2.67-.559.951 0 1.961.481 2.681 1.317-2.357 1.202-1.974 4.339.408 5.179zm-3.733-7.516c.473-.525.837-1.267.706-2.023-.777.045-1.686.472-2.216 1.023-.481.504-.878 1.252-.723 1.976.846.023 1.723-.412 2.233-.976z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8IphoneX);
